import { useQuery } from '@tanstack/react-query'
import { winnersApi } from '@/shared/api'
import { QUERY_KEYS } from '@/shared/config'
import type { Winner } from '@/shared/types'

export function useWinners(limit?: number) {
  return useQuery<Winner[]>({
    queryKey: QUERY_KEYS.WINNERS.ALL,
    queryFn: () => winnersApi.getAll(limit),
    refetchInterval: 5000,
    staleTime: 3000,
  })
}
